// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"9a506f47","112":"5d520354","368":"f002c109","392":"cd9ee36e","700":"a986b3ae","744":"b8461455"}[chunkId] + ".chunk.css";
};